import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {colors} from "nxtconstants";

const propTypes = {
  signUpData: PropTypes.shape({
    heading: PropTypes.shape({
      line1: PropTypes.string,
      highlight: PropTypes.string
    }),
    ctaText: PropTypes.string,
    ctaUrl: PropTypes.string
  })
};

const defaultSignUpData = {
  heading: {
    line1: "Join 14,000+ Wealth Partners on India's fastest growing platform for",
    highlight: "Mutual Fund Distributors"
  },
  ctaText: "Sign Up Now",
  ctaUrl: "#register"
};

const FloatingSignUp = ({signUpData = {}}) => {
  const heading = {
    ...defaultSignUpData.heading,
    ...(signUpData.heading || {})
  };
  const ctaText = signUpData.ctaText || defaultSignUpData.ctaText;
  const ctaUrl = signUpData.ctaUrl || defaultSignUpData.ctaUrl;

  return (
    <FloatingBar aria-label="Join Wealthy">
      <BarInner>
        <Message>
          {heading.line1}{" "}
          <Highlight>{heading.highlight}</Highlight>
        </Message>

        <CtaButton href={ctaUrl}>{ctaText}</CtaButton>
      </BarInner>
    </FloatingBar>
  );
};

FloatingSignUp.propTypes = propTypes;

const FloatingBar = styled.div`
  position: fixed;
  left: 50%;
  border: 1px solid ${colors.lightGray};
  border-radius: 1.6rem;
  bottom: 2rem;
  transform: translateX(-50%);
  width: 85%;
  max-width: 125rem;
  z-index: 997;
  pointer-events: none;

  @media (max-width: 768px) {
    bottom: 1.2rem;
    width: 85%;
  }
`;

const BarInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  padding: 1.6rem 2.4rem;
  border-radius: 1.6rem;
  background: ${colors.white};
  box-shadow: 0 0.8rem 2.4rem rgba(17, 8, 32, 0.12);
  pointer-events: auto;

  @media (max-width: 768px) {
    gap: 1.2rem;
    padding: 1.2rem 1.4rem;
    border-radius: 1.6rem;
  }
`;

const Message = styled.p`
  flex: 1;
  margin: 0;
  font-family: "DM Serif Display";
  font-size: 2.4rem;
  font-weight: 400;
  line-height: 1.3;
  color: ${colors.textBlack};

  @media (max-width: 768px) {
    font-size: 1.6rem;
    line-height: 1.35;
  }
`;

const Highlight = styled.span`
  display: inline-block;
  background: linear-gradient(
    90deg,
    ${colors.pastelPurple} 0%,
    ${colors.pastelPurple} 40%,
    #d8c4ff 50%,
    ${colors.pastelPurple} 60%,
    ${colors.pastelPurple} 100%
  );
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  animation: shimmer 2.5s ease-in-out infinite;

  @keyframes shimmer {
    0% {
      background-position: 100% center;
    }

    100% {
      background-position: -100% center;
    }
  }
`;

const CtaButton = styled.a`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${colors.primary};
  color: ${colors.white};
  border: none;
  border-radius: 5rem;
  padding: 1rem 3.2rem;
  font-family: "Lato";
  font-size: 1.6rem;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;

  @media (max-width: 768px) {
    padding: 0.8rem 1.6rem;
    font-size: 1.3rem;
  }
`;

export default FloatingSignUp;
